import { STATUS_DELETED } from 'constants/MediaConstants';
import { getExtension } from 'utils/fileName';

/**
 * @param {File} file
 * @param intl
 * @param allowedFileExtensions
 * @param allowedFileTypes
 */
export const allowedFileValidator = (file, intl, allowedFileExtensions, allowedFileTypes) => {
  const { type, name } = file;
  const fileExtension = getExtension(name);
  const isAllowedExtension = allowedFileExtensions
    .map(extension => extension.toUpperCase())
    .includes(fileExtension.toUpperCase());

  const isAuthorized = (allowedFileTypes?.includes(type) ?? true) || isAllowedExtension;

  if (!isAuthorized) {
    return intl.formatMessage({
      id: 'action.file_type_not_allowed',
      defaultMessage: 'This type of file is not allowed',
    });
  }
  return undefined;
};

/** @param {File} file
 * @param validators
 */
export const getError = async (file, validators) => {
  for (const rule of validators) {
    if (typeof rule === 'function') {
      // eslint-disable-next-line no-await-in-loop
      const error = await rule(file);
      if (error) {
        return error;
      }
    }
  }
  return undefined;
};

export const isMediaDeleted = ({ status, data } = {}) => status === STATUS_DELETED || data?.status === STATUS_DELETED;
export const filterDeletedMedia = (mediaList = []) => (mediaList.filter(media => !isMediaDeleted(media)));
